module.exports = __webpack_public_path__ + "images/morning-wood-68bb618d990a23dcbd165b2b1f04394e.png";